import React from 'react';
import reducer from './reducer';

export const MessageContext = React.createContext({});

const initial = { type: null, content: null };

const MessageData = ({ children }) => {
    const [state, dispatch] = React.useReducer(reducer, initial);
    return (
        <MessageContext.Provider value={[state, dispatch]}>
            {children}
        </MessageContext.Provider>
    );
};

export default MessageData;
